(function() {
    'use strict';

    angular.module('elogbooks.user.manage-operatives', []);
})();
